import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponseMessages } from '../../../../../../projects/ppb-shared-library/src/lib/models/global.model';
import {
  HttpResponseToasterInterceptor
} from '../../../../../../projects/ppb-shared-library/src/lib/pseic-toaster/http-response-toaster.interceptor';

@Injectable({
  providedIn: 'root'
})
export class PpbToasterInterceptor extends HttpResponseToasterInterceptor {

  isEmpty(httpErrorResponse: HttpErrorResponse): boolean {
    const apiResponseMessages = httpErrorResponse.error as ApiResponseMessages;
    return !(apiResponseMessages.messages && apiResponseMessages.messages.length > 0);
  }

  protected handleError(errorResponse: HttpErrorResponse): void {
    const withToaster = true;
    const printable = true;
    const messagesWithoutToaster = this.filterMessages(errorResponse, !withToaster);
    const messagesWithPrintableToaster = this.filterMessages(errorResponse, withToaster, printable);

    if (this.isEmpty(messagesWithoutToaster)) {
      super.handleError(errorResponse);
    } else if (!this.isEmpty(messagesWithPrintableToaster)) {
      super.handleError(messagesWithPrintableToaster);
    }
  }

  private filterMessages(
    httpErrorResponse: HttpErrorResponse,
    withToaster: boolean,
    printable?: boolean
  ): HttpErrorResponse {
    const apiResponseMessages = httpErrorResponse.error as ApiResponseMessages;
    if (apiResponseMessages.messages) {
      return {
        ...httpErrorResponse,
        error: {
          ...apiResponseMessages,
          messages: apiResponseMessages.messages.filter(message => [
                'msg.err.account.reset.password.email.link.account.not.active',
                'msg.err.account.reset.password.email.link.expired',
                'msg.err.account.reset.password.email.link.account.disable',
                'msg.err.account.reset.password.email.link.account.blocked'
              ].includes(message.code) !== withToaster
              && (printable === undefined || message.printable === printable)
          )
        }
      };
    }
    return httpErrorResponse;
  }

}
